import type { ActionReducerMapBuilder } from '@reduxjs/toolkit';

import {
  BDRequestStatus,
  BDRequestType,
} from '~/common/models/apis/apiResponse.model';
import type { BDError } from '~/common/models/error.model';

import { CAMERAS_SETTINGS_ACTIONS } from './camerasSettingsSlice.action';
import type {
  CamerasSettingsParams,
  CamerasSettingsRequestContext,
  CamerasSettingsState,
} from './camerasSettingsSlice.model';

const getRequestContext = ({
  organizationsId,
  hubsId,
  fleetsId,
}: CamerasSettingsParams): CamerasSettingsRequestContext => ({
  organizationsId,
  hubsId,
  fleetsId,
});

export const buildFetchCamerasSettingsReducer = (
  builder: ActionReducerMapBuilder<CamerasSettingsState>
) => {
  builder.addCase(
    CAMERAS_SETTINGS_ACTIONS.fetchCamerasSettings.pending,
    (state, action) => {
      state.operations[BDRequestType.GET_ALL] = {
        status: BDRequestStatus.PENDING,
        errors: [],
      };
      state.fetchSettingsContext = getRequestContext(action.meta.arg);
    }
  );
  builder.addCase(
    CAMERAS_SETTINGS_ACTIONS.fetchCamerasSettings.fulfilled,
    (state, action) => {
      state.operations[BDRequestType.GET_ALL] = {
        status: BDRequestStatus.SUCCEEDED,
        errors: [],
      };
      state.settings = action.payload.result;
      state.fetchSettingsContext = getRequestContext(action.meta.arg);
    }
  );
  builder.addCase(
    CAMERAS_SETTINGS_ACTIONS.fetchCamerasSettings.rejected,
    (state, action) => {
      state.operations[BDRequestType.GET_ALL] = {
        status: BDRequestStatus.FAILED,
        errors: [action.payload as BDError],
      };
      state.fetchSettingsContext = getRequestContext(action.meta.arg);
    }
  );
};

export const buildUpdateCamerasSettingsReducer = (
  builder: ActionReducerMapBuilder<CamerasSettingsState>
) => {
  builder.addCase(
    CAMERAS_SETTINGS_ACTIONS.updateCamerasSettings.pending,
    (state) => {
      state.operations[BDRequestType.UPDATE] = {
        status: BDRequestStatus.PENDING,
        errors: [],
      };
    }
  );
  builder.addCase(
    CAMERAS_SETTINGS_ACTIONS.updateCamerasSettings.fulfilled,
    (state) => {
      state.operations[BDRequestType.UPDATE] = {
        status: BDRequestStatus.SUCCEEDED,
        errors: [],
      };
    }
  );
  builder.addCase(
    CAMERAS_SETTINGS_ACTIONS.updateCamerasSettings.rejected,
    (state, action) => {
      state.operations[BDRequestType.UPDATE] = {
        status: BDRequestStatus.FAILED,
        errors: [action.payload as BDError],
      };
    }
  );
};

export const CAMERAS_SETTINGS_EXTRA_REDUCER_BUILDERS = {
  buildFetchCamerasSettingsReducer,
  buildUpdateCamerasSettingsReducer,
};
